import { makeCRUDSlice } from '@redux/crudCreator';
import {
  MODEL_NAME,
  getAllProductVariantByProductId,
  getProductVariantDetail,
  productVariantsActions,
} from './actions';
import {
  getAllSuccess,
  getAll,
  getAllFailure,
  getDataById,
} from '@redux/crudCreator/slice';

const slice = makeCRUDSlice(MODEL_NAME, productVariantsActions, {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [getProductVariantDetail.pending as any]: getDataById,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [getProductVariantDetail.fulfilled as any]: (
    state,
    { payload: { data } },
  ) => {
    state.data = { ...state.data, [data.id]: data };
    state.currentData = data;
    state.itemLoadings = { ...state.itemLoadings, [data.id]: false };
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [getAllProductVariantByProductId.pending as any]: getAll,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [getAllProductVariantByProductId.fulfilled as any]: getAllSuccess,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [getAllProductVariantByProductId.rejected as any]: getAllFailure,
});

export default slice.reducer;
